import { render } from "./ClientsPage.vue?vue&type=template&id=4a41aaac"
import script from "./ClientsPage.vue?vue&type=script&lang=js"
export * from "./ClientsPage.vue?vue&type=script&lang=js"

import "./ClientsPage.vue?vue&type=style&index=0&id=4a41aaac&lang=scss"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__